const DeclineInputField = {
    No: 0,
    DeclinedInProgress: 1,
    Declined: 2,
    UserSentBack: 3
}

export default DeclineInputField